module.exports = __webpack_public_path__ + "static/img/_MG_4577-slim-top.937d192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_MG_4577-slim-top.jpg
// module id = 0t/Q
// module chunks = 0